import { render, staticRenderFns } from "./top-logo.vue?vue&type=template&id=2f3c85b6&scoped=true&"
import script from "./top-logo.vue?vue&type=script&lang=js&"
export * from "./top-logo.vue?vue&type=script&lang=js&"
import style0 from "./top-logo.vue?vue&type=style&index=0&id=2f3c85b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c85b6",
  null
  
)

export default component.exports